import { createContext, FunctionalComponent, h } from 'preact';
import { useContext, useReducer } from 'preact/hooks';

type CheckoutStateType = Partial<CheckoutWidgetStoreType>;

type Action = {
  type: 'STORE_STATE' | 'RESET_STORE' | 'SEND_MESSAGE',
  payload?: CheckoutStateType,
};

type Dispatch = (action: Action) => void;

const CheckoutContext = createContext({
  checkoutState: {},
});

const CheckOutDispatchContext = createContext({
  checkoutDispatch: () => {},
});

const CheckoutProvider: FunctionalComponent = ({ children }) => {
  const reducer = (
    state: CheckoutStateType,
    action: Action,
  ): CheckoutStateType => {
    switch (action.type) {
      case 'STORE_STATE':
        return {
          ...state,
          ...action.payload,
        };
      case 'SEND_MESSAGE':
        console.log({ action });
        const data = action.payload;

        if (state.merchantOrigin && data) {
          const sendMessage = (messageData) => {
            return window.parent.postMessage(
              JSON.stringify(messageData),
              state.merchantOrigin,
            );
          };

          switch (data.actionName) {
            case 'onTransactionComplete':
              sendMessage({
                actionName: data.actionName,
                payload: data.payload,
                signature: data.signature,
              });
              break;
          }
        }

        return state;
      case 'RESET_STORE':
        return {};
      default:
        return state;
    }
  };

  const initialState = {
    merchantName: '',
    mobileNo: '',
    amount: '',
    userDetailsConfig: {
      showMobileContainer: false,
      showEditIcon: false,
    },
    eligibilityDetails: '',
    selectedLenderDetails: null,
    selectedEmiPlanDetails: null,
    merchantOrigin: '*',
    closeIconConfig: {
      showCloseIcon: true,
      shouldShowCancellationPopup: true,
      showCancellationPopup: false,
    },
  };

  const [checkoutState, checkoutDispatch] = useReducer(reducer, initialState);

  const value = checkoutState;

  const dispatchValue = checkoutDispatch;

  return (
    <CheckoutContext.Provider value={value}>
      <CheckOutDispatchContext.Provider value={dispatchValue}>
        {children}
      </CheckOutDispatchContext.Provider>
    </CheckoutContext.Provider>
  );
};

const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);
  return context;
};

const useCheckoutDispatchContext = () => {
  const context = useContext(CheckOutDispatchContext);
  return context;
};

export { CheckoutProvider, useCheckoutContext, useCheckoutDispatchContext };



// WEBPACK FOOTER //
// ./storeProviders/checkoutWidgetStore/index.js